/** El logo de BCN PD. Las letras de «FIVE» son blancas, así que en el tema claro se usa la variante oscura. */
import { useTemaOscuro } from './tema'

export function Logo({ ancho, className = '' }: { ancho: number; className?: string }) {
  const oscuro = useTemaOscuro()
  return (
    <img
      className={`logo ${className}`.trim()}
      src={oscuro ? '/logo.png' : '/logo-claro.png'}
      alt="BCN PD"
      width={ancho}
      height={Math.round(ancho * 0.495)}
    />
  )
}
